import { t } from '@lingui/core/macro';
import { createContext, use, type ReactNode } from 'react';

export type ChangePasswordResult = { readonly ok: true } | { readonly ok: false; readonly message: string };

/**
 * O que o perfil precisa da sessão Cognito, que mora em `src/app/auth` (o módulo não importa `app`).
 * A rota de layout `/_app/meu-perfil` liga `useAuth()` aqui; testes e `/dev` passam uma sessão fictícia.
 */
export interface ProfileSession {
  /** Username do Cognito: o `user.id` do legado (`identityContext.tsx:108-114`). */
  readonly username: string | undefined;
  /** `changePassword(atual, nova)`; nunca registre os argumentos (U24, U30). */
  changePassword(oldPassword: string, newPassword: string): Promise<ChangePasswordResult>;
}

const missing: ProfileSession = {
  username: undefined,
  changePassword: () => Promise.resolve({ ok: false, message: t`Não foi possível alterar a senha. Sessão não encontrada.` }),
};

const ProfileSessionContext = createContext<ProfileSession>(missing);

export function ProfileSessionProvider({ value, children }: { readonly value: ProfileSession; readonly children: ReactNode }) {
  return <ProfileSessionContext value={value}>{children}</ProfileSessionContext>;
}

export const useProfileSession = () => use(ProfileSessionContext);
